(function ($, slickcarousel) {

  $(document).ready(function () {


    $('.section-slider__content').slick({
      infinite: true,

      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      autoplay: true,
      arrows: false,
      autoplaySpeed: 4000,
      fade: true,
      cssEase: 'linear'
    });


    
  });

})(jQuery, SlickCarousel);



//////////////////
// WEBPACK FOOTER
// ../src/js/components/home/slider.js
// module id = 0
// module chunks = 3